/**
 * 承認ダイアログ（メディアクエリ対応版）
 *
 * 責務:
 * - メディアクエリに基づいてデスクトップ版/モバイル版を切り替え
 */
import { createFileRoute } from "@tanstack/react-router";

import { useDesktopOrMobileMediaQuery } from "@/hooks/useMediaQuery";

import { ApprovalDialogDesktop } from "./-components/approval-dialog/ApprovalDialogDesktop";
import { ApprovalDialogMobile } from "./-components/approval-dialog/ApprovalDialogMobile";

export const Route = createFileRoute(
  "/_individual/individual/task/$id/approval-dialog",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { isDesktop } = useDesktopOrMobileMediaQuery();

  // デスクトップ版とモバイル版を切り替え
  return isDesktop ? (
    <ApprovalDialogDesktop taskId={id} />
  ) : (
    <ApprovalDialogMobile taskId={id} />
  );
}
